import React from 'react';

import { Badge } from 'AWS-UI-Components-React';

import { AppLayout, Tooltip } from 'AWS-UI-Components-React';

import { MapperForm } from './mapper_form';
import { isPowerUser } from '../../utils/access-utils';

export const Change = {
  ADD: 'New',
  MODIFY: 'Modified',
  DELETE: 'Deleted',
};

export const Badges = {
  New: (item) => {
    return (
      <span key="new">
        { item }
        { '  ' }
        <Badge color="green" content={ Change.ADD } />
      </span>
    );
  },
  Modified: (item) => {
    return (
      <span key="modified">
        { item }
        { '  ' }
        <Badge color="blue" content={ Change.MODIFY } />
      </span>
    );
  },
  Deleted: (item) => {
    return (
      <span key="deleted">
        <del>{ item }</del>
        { '  ' }
        <Badge color="red" content={ Change.DELETE } />
      </span>
    );
  },
  Excluded: (text) => {
    return (
      <Tooltip key="excluded" text={ text } position="top">
        { ' ' }
        <Badge color="grey" content="Excluded" />
      </Tooltip>
    );
  },
  Ignored: (text) => {
    return (
      <Tooltip key="ignored" text={ text } position="top">
        { ' ' }
        <Badge color="red" content="Ignored" />
      </Tooltip>
    );
  },
};

export const KeyOriginalMapping = {
  'cpValueMap': 'originalCPValueMap',
  'accuracyBenchmark': 'originalAccuracyBenchmark',
  'cognosBenchmark': 'originalCognosBenchmark',
};

export class Mapper extends React.Component {
  render() {
    return (
      <div>
        <AppLayout
          className="awsui-util-no-gutters"
          content={ <MapperForm identity={ this.props.identity } readOnly={ !isPowerUser(this.props.identity) } /> }
          navigationHide={ true }
          toolsHide={ true }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/mapper/mapper.jsx